import templateUrl from 'emun.salesrep/salesrep-showroom-dashboard.htm'
import controller from 'emun.salesrep/salesrep-showroom-dashboard.controller'

//class ShowroomDashboardController  {
//    constructor(createAutoQuery, $session, $window, $state) {
//        basicController(this)
//        var map = this;
//        let $ctrl = this;
//        $ctrl.salesrepConfig = salesrepConfig;
//        $ctrl.chartLoaded = false;
//        this.productImage = $appConfig.productImage.bind($appConfig);
//        $ctrl.currentReport = "";
//		$ctrl.showCodes = [];
//		$ctrl.markets = [];
//		$ctrl.showCodesQuery = createAutoQuery({
//			url: 'QueryMarketDates.json',
//			autoLoad: true,
//			take: 1000,
//			onLoaded: function (args) {
//				args.results.forEach(function (market) {
//					if ($ctrl.markets.filter(m => m.market == market.market && m.year == market.year).length == 0) {
//						$ctrl.markets.push(market);
//					}
//				});
//			}
//		});

//        this.$session = $session;
//    }
//    load(){return this.query.load.apply(this.query, arguments);}
//}

let SalesrepShowroomDashboard = {
    bindings: {
        repId: '@'
    },
	controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default SalesrepShowroomDashboard